import { Preview } from "@creatomate/preview";

const movePlayhead = async (preview: Preview, time: number) => {
  if (preview.ready) await preview.setTime(time);
};

export default movePlayhead;
